import { implementCustomExpressions } from '../__generated/implementation.js'
import type { PricingConfig } from '../data/pricing-config.js'

export const topWithDiameterExpressions = implementCustomExpressions({
  TopWithDiameter: {
    $width: s => s.diameter,
    $length: s => s.diameter,
    $sizeDescription: s => `${Math.round(s.diameter)}"`,
    $price: s => {
      const p = s.$table.$pricingConfig as PricingConfig
      const pricing = p.tops[s.type] ?? { basePrice: 0, compoundingRate: 0.05, pricingStep: 6 }
      const diameterSteps = Math.trunc(
        (Math.round(s.diameter) - s.$topDataMap[s.type].sizing.diameter.default) / pricing.pricingStep
      )

      return Math.round(pricing.basePrice * Math.pow(1 + pricing.compoundingRate, diameterSteps))
    },
    $minWidth: s => s.$topDataMap[s.type].sizing.diameter.min,
    $maxWidth: s => s.$topDataMap[s.type].sizing.diameter.max,

    $defaultDiameter: s => s.$topDataMap[s.type].sizing.diameter.default,
    $defaultWidth: s => s.$defaultDiameter,
    $defaultLength: s => s.$defaultDiameter,

    $distance: s => {
      return s.$leafCenterVisible ? s.$leafLength * s.leafAmount : 0
    },
    $distanceScaleZero: () => {
      // scaleZero = 0 means no separation (shape key at 0)
      return 0
    },
    $distanceScaleOne: s => {
      // scaleOne = scaleDelta means full separation range
      return s.$topDataMap[s.type].sizing.distance.scaleDelta
    },
    $leafBevel: s => {
      // When leaf is enabled, set to scaleOne to show bevel edge in the middle
      return s.$leafCenterVisible ? 0.05 : 0
    },
    $leafBevelScaleZero: () => 0,
    $leafBevelScaleOne: () => 0.05,
  },
})
